import { type AxiosResponse } from 'axios';

import { MEETING_OPEN_TAB } from '../config/apiPaths';
import HttpClient from '../utils/httpClient';
import { processApiPath } from '../utils/url';

export type LaunchWhiteboardPaylaod = {
    title: string;
    tab_type: 'whiteboard';
    control_type: 'manual';
    data: {
        uniqueId: string;
        url: string;
        data?: any;
        breakout_names?: string[];
    };
};

export type LaunchWhiteboardResponse = {
    success: boolean;
    class_session_note_id: string;
};

export const launchWhiteboard = async (
    payload: LaunchWhiteboardPaylaod,
    meetingId: string,
    token: string
): Promise<AxiosResponse<LaunchWhiteboardResponse>> => {
    const httpClient = new HttpClient({}, { retryAnyError: true });

    const url = processApiPath(MEETING_OPEN_TAB, { meetingId });

    return httpClient.post(url, payload, {
        headers: {
            Token: token
        }
    });
};
